import { DAILY_PRIZE_GUESS, DAILY_PRIZE_GUESSES, DAILY_PRIZE_GUESSES_ALL, DAILY_PRIZE_HISTORY, DAILY_PRIZE_POOL, DAILY_PRIZE_STATUS } from './contants';

const initState = {
	dailyPrizeStatus: [],
	dailyPrizeGuess: [],
	dailyPrizeGuessAll: [],
	dailyPrizeHistory: [],
	dailyPrizeGuesses
		: [],
	dailyPrizePrizePool: [],
	// Master = hạng cao nhất, suy ra từ rank của login-streak. Để ở store cho
	// mọi nơi (Home, DailyReward...) dùng chung thay vì tự tính lại.
	isMaster: false,
}

const reducerDailyPrizeStatus = (state = initState, actions) => {
	switch (actions.type) {
		case DAILY_PRIZE_STATUS:
			return {
				...state,
				dailyPrizeStatus: actions.payload.data,
				isMaster: actions.payload.data?.rank?.toUpperCase() === 'MASTER',
			}
		case DAILY_PRIZE_GUESS:
			return {
				...state,
				dailyPrizeGuess: actions.payload.data,
			}
		case DAILY_PRIZE_GUESSES_ALL:
			return {
				...state,
				dailyPrizeGuessAll: actions.payload.data,
			}
		case DAILY_PRIZE_HISTORY:
			return {
				...state,
				dailyPrizeHistory: actions.payload.data,
			}
		case DAILY_PRIZE_GUESSES:
			return {
				...state,
				dailyPrizeGuesses: actions.payload.data,
			}
		case DAILY_PRIZE_POOL:
			return {
				...state,
				dailyPrizePrizePool: actions.payload.data,
			}
		default:
			return state
	}
}
export default reducerDailyPrizeStatus
